import React, { Component } from "react";
import ReactDOM from "react-dom";

import { connect } from "react-redux";
import { Router, Route, Switch } from "react-router-dom";
import { Provider } from "react-redux";

import { getSubDomain, history, updateFavicon } from "./helpers";
import Auth from "./helpers/auth";
import { configureStore } from "./store/configureStore";

import LogIn from "./screens/LogIn";
import Register from "./screens/Register";
import VideoSession from "./screens/VideoSession";
import Home from "./screens/Home";
import EmailVerification from "./screens/EmailVerification";
import CreateAppointment from "./components/CreateAppointment/index";
import NotFound from "./components/Not Found";
import VerificationView from "./components/Verification";
import CounsellorHome from "./screens/CounsellorHome/index";
import CounsellorLogIn from "./screens/CounsellorLogIn";
import ForgotPassword from "./screens/ForgotPassword";
import MyCounsellor from "./screens/MyCounsellor";
import MyPatients from "./screens/MyPatients/MyPatients";
import unregister from "./registerServiceWorker";
import ConfirmationView from "./components/Confirmation";
import ConfirmationPassword from "./components/ConfirmationPassword";
import PasswordChanged from "./components/PasswordChanged";
import TermsandCondition from "./components/Terms and Condition";
import PrivacyAndPolicy from "./components/PrivacyAndPolicy";
import Note from "./screens/NoteScreen";
import NoteView from "./screens/NoteView";
import CounselorDatePicker from "./screens/CounselorDatePicker";
import ViewCounselorSlots from "./screens/ViewCouselorSlots";
import { WhitelabelActions } from "./store/actions";
import CounsellorList from "./screens/CounsellorList";
import CounsellorPublicList from './screens/CounsellorPublicList';
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import { enable_Bugsnag, bugsnag_APIKEY, gtmId } from "./config";
import Faq from "./screens/Faq";
import CounsellorAppointment from "./screens/CounsellorAppointment";
import RequestAppointment from "./components/RequestAppointment";
import { injectIntl, IntlProvider, FormattedRelative, useIntl } from "react-intl";
import CounsellorProfile from './screens/CounsellorProfile';
import CounsellorPublicProfile from './screens/CounsellorPublicProfile';
import SessionHistory from "./screens/SessionHistory";
import ProtectedRoute from "./Routes/Routes"
import "./static/style/main.css";
import SessionDetails from "./screens/SessionDetails";
import ViewFamilyMember from "./screens/FamilyMemberList/index";
import AddFamilyMember from "./screens/AddFamilyMemberForm";
import PatientDetails from "./screens/PatientDetails";
import { initializeGTM } from "./helpers/analytics";

process.env.NODE_CONFIG_DIR = "../config";

class MainApp extends Component {
  componentDidMount() {
    const domainName = getSubDomain();
    if (domainName) {
      updateFavicon(domainName)
    }
    if (gtmId) {
      initializeGTM();
    }
  }

  render() {
    return (
      <Router history={history}>
        <Switch>
          <Route exact path="/tandc" component={TermsandCondition} />
          <Route exact path="/privacypolicy" component={PrivacyAndPolicy} />
          <Route exact path="/faq" component={Faq} />

          <Route path="/registration" component={Register} />

          <Route exact path="/login/counsellor" component={CounsellorLogIn} />
          <Route exact path="/profile/:name" component={CounsellorPublicProfile} />
          <Route exact path="/list-of-counsellors" component={CounsellorPublicList} />
          <Route exact path="/verification" component={VerificationView} />
          <Route exact path="/confirmation" component={ConfirmationView} />
          <Route exact path="/passwordchanged" component={PasswordChanged} />
          <Route exact path="/confirmation/forgotpassword" component={ConfirmationPassword} />
          <Route exact path="/emailverification" component={EmailVerification} />
          <Route exact path="/forgotpassword/:code" component={ForgotPassword} />
          <Route exact path="/" component={LogIn} />

          <ProtectedRoute exact path="/family_member" component={ViewFamilyMember} />
          <ProtectedRoute exact path="/family_member/add" component={AddFamilyMember} />
          <ProtectedRoute path="/create_appointment/:id" component={CreateAppointment} />
          <ProtectedRoute exact path="/home" component={Home} />
          <ProtectedRoute exact path="/note" component={Note} />
          <ProtectedRoute exact path="/appointment-details/:appointmentId" component={SessionDetails}/>
          <ProtectedRoute exact path="/patient-details/:patientId" component={PatientDetails}/>
          <ProtectedRoute exact path="/sessions-history" component={SessionHistory} />
          <ProtectedRoute exact path="/noteview/:noteid" component={NoteView} />
          <ProtectedRoute exact path="/counselor/slotpicker/:email?" component={CounselorDatePicker} />

          <ProtectedRoute exact path="/counselor/slots" component={ViewCounselorSlots} />
          <ProtectedRoute exact path="/home/counsellor" component={CounsellorHome} />
          <ProtectedRoute exact path="/session/:id/:token/:appointment" component={VideoSession} />
          <ProtectedRoute exact path="/counsellor-list" component={CounsellorList} />
          <ProtectedRoute exact path="/my-counsellor" component={MyCounsellor} />
          <ProtectedRoute exact path="/my-patients" component={MyPatients} />
          <ProtectedRoute exact path="/counsellor/appointments" component={CounsellorAppointment} />
          <ProtectedRoute exact path="/counsellor/profile/:id" component={CounsellorProfile} />
          <ProtectedRoute exact path="/request/session/:date_time/:patient_id" component={RequestAppointment} />
          <Route component={NotFound} />


        </Switch>
      </Router>
    );
  }
}

function mapStateToProps(state) {
  const { alert } = state;
  return {
    alert,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchWhitelabel: () => {
      dispatch(WhitelabelActions.fetchWhitelabel());
    },
    setWhitelabel: () => {
      dispatch(WhitelabelActions.setWhitelabel());
    },
  };
}

const App = connect(mapStateToProps, mapDispatchToProps)(MainApp);

if (enable_Bugsnag == true) {
  Bugsnag.start({
    apiKey: bugsnag_APIKEY,
    plugins: [new BugsnagPluginReact()],
  });
  const ErrorBoundary = Bugsnag.getPlugin("react").createErrorBoundary(React);
  ReactDOM.render(
    <ErrorBoundary>
      <Provider store={configureStore}>
        <IntlProvider locale={navigator.language}>
          <App />
        </IntlProvider>
      </Provider>
    </ErrorBoundary>,
    document.getElementById("root")
  );
} else {
  ReactDOM.render(
    <Provider store={configureStore}>
      <IntlProvider locale={navigator.language}>
        <App />
      </IntlProvider>
    </Provider>,
    document.getElementById("root")
  );
}
unregister();



// WEBPACK FOOTER //
// ./src/index.js